module.exports = __webpack_public_path__ + "static/media/seo.c68e7b85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/seo/seo.jpg
// module id = 417
// module chunks = 0